import React, { useState } from 'react';
//import './Checkout.css';
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from '../../../../../globals/firebase';


const Checkout = (price) => {
    const [{ options, isPending }, dispatch] = usePayPalScriptReducer();

    const prices=price.price

    const setcredits = async () => {

        const user = JSON.parse(localStorage.getItem("user"))
    
        const docRef = doc(db, "wpm_users", user.userid)
        const userdoc = await getDoc(docRef);
        // Set the "capital" field of the city 'DC'
        await updateDoc(docRef, {
          creditsprompts: userdoc.data().creditsprompts + prices.prompts,
          creditsimages: userdoc.data().creditsimages + prices.images,
        });

        window.location.href="/job-list"
    
        
      }

    const onCreateOrder = (data,actions) => {
        return actions.order.create({
            purchase_units: [
                {
                    amount: {
                        value: prices.pricep + prices.pricei,
                    },
                },
            ],
        });
    }

    const onApproveOrder = (data,actions) => {
        return actions.order.capture().then((details) => {
            const name = details.payer.email;
            //alert(`Transaction completed by ${name}`);
            setcredits()
        });
    }

    return (
        <div className="checkout">
            {isPending ? <p>LOADING...</p> : (
                <>
                        <PayPalButtons 
                        style={{ layout: "vertical" }}
                        createOrder={(data, actions) => onCreateOrder(data, actions)}
                        onApprove={(data, actions) => onApproveOrder(data, actions)}
                    />
                </>
            )}
        </div>
    );
}

export default Checkout;